export const openNewTab = (link) => {
  const newWnd = window.open(link);
  newWnd.opener = null;
};

export const navigateToLegacy = (path = '/', options = {}) => {
  const url = `${window._env_.LEGACY_APP_REDIRECT_DOMAIN}${path}`;
  const { newTab } = options;

  newTab ? window.open(url) : (window.location.href = url);
};

export const navigateToCMS = (path = '/', options = {}) => {
  const url = `${window._env_.APP_DOMAIN}${path}`;
  const { newTab } = options;

  newTab ? window.open(url) : (window.location.href = url);
};
